import React from 'react'
import CardsPage from 'Event/template/Cards/Page'
import FaqList from 'Event/template/Cards/FAQs/FaqList'
import {User} from 'auth/user'
import {PageTitle, PageDescription} from 'Event/template/Cards/Page'
import {useAttendeeVariables} from 'Event'
import {useCardsTemplate} from 'Event/template/Cards'
import HTMLContent from 'lib/ui/form/HTMLEditor/HTMLContent'
import Configurable from 'organization/Event/Configurable'
import AddFaqButton from 'Event/FAQs/AddFaqButton'
import TitleConfig from 'Event/FAQs/TitleConfig'
import DescriptionConfig from 'Event/FAQs/DescriptionConfig'

export default function Faqs(props: {user: User}) {
  const template = useCardsTemplate()
  const {faq: pageSettings, linkColor, linkUnderline} = template
  const v = useAttendeeVariables()

  return (
    <CardsPage user={props.user}>
      <AddFaqButton />
      <Configurable>
        <TitleConfig />
        <PageTitle aria-label="faqs title">{v(pageSettings?.title)}</PageTitle>
      </Configurable>
      <Configurable>
        <DescriptionConfig />
        <PageDescription linkColor={linkColor} linkUnderline={linkUnderline}>
          <HTMLContent aria-label="description">
            {v(pageSettings?.description)}
          </HTMLContent>
        </PageDescription>
      </Configurable>
      <FaqList />
    </CardsPage>
  )
}
